module.exports = "/_next/static/images/d8e8f9969c5bda934bd832b5fc30a07d-10-million.svg";